import { createFileRoute } from "@tanstack/react-router";

import { prefetchForProject } from "../../../lib/prefetch";
import { Worlds } from "./-worlds";
import { parseWorldsFilters } from "../../../workspaces/worlds/search";

export const Route = createFileRoute("/_console/p/$org/$project/simulate/")({
  validateSearch: parseWorldsFilters,
  loaderDeps: ({ search }) => ({ query: search.q }),
  loader: ({ context: { queryClient }, params, deps }) =>
    prefetchForProject(
      queryClient,
      params,
      import("../../../workspaces/worlds/queries"),
      ({ prefetchWorldLists }, projectId) => prefetchWorldLists(queryClient, projectId, deps.query),
    ),
  component: WorldsIndexRoute,
});

/** Every simulation asset, with none inspected. */
function WorldsIndexRoute() {
  return <Worlds state={Route.useSearch()} />;
}
